// extracted by mini-css-extract-plugin
export var article = "AccordionItem-module--article--b889f";
export var button = "AccordionItem-module--button--d803c";
export var content = "AccordionItem-module--content--76e33";
export var heading = "AccordionItem-module--heading--7c499";
export var isActive = "AccordionItem-module--isActive--3d3a7";
export var richText = "AccordionItem-module--richText--c7e58";